import React, { useEffect, useState } from 'react';
import AdminLayout from './AdminLayout';
import { getAdminUsersApi } from '../../utils/api';

export default function AdminUsers() {
  const [users,   setUsers]   = useState([]);
  const [loading, setLoading] = useState(true);
  const [search,  setSearch]  = useState('');

  useEffect(() => {
    getAdminUsersApi().then(({ data }) => setUsers(data)).finally(() => setLoading(false));
  }, []);

  const filtered = users.filter(u =>
    u.name.toLowerCase().includes(search.toLowerCase()) ||
    u.email.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <AdminLayout title="Users">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
        <input
          value={search}
          onChange={e => setSearch(e.target.value)}
          placeholder="Search by name or email…"
          className="form-control"
          style={{ maxWidth: 320 }}
        />
        <span style={{ color: 'var(--text3)', fontSize: '0.88rem' }}>{users.length} registered users</span>
      </div>

      {loading ? <div className="spinner" /> : (
        <div style={{ background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 'var(--radius-lg)', overflow: 'hidden' }}>
          <div style={{
            display: 'grid', gridTemplateColumns: '1.8fr 2fr 1fr 1fr 1fr',
            padding: '12px 24px', background: 'var(--bg2)',
            fontWeight: 700, fontSize: '0.72rem', color: 'var(--text3)',
            textTransform: 'uppercase', letterSpacing: '0.08em', gap: 12,
          }}>
            <span>User</span><span>Email</span><span>Books</span><span>Chapters</span><span>Joined</span>
          </div>

          {filtered.length === 0 && (
            <div style={{ padding: '40px', textAlign: 'center', color: 'var(--text3)' }}>No users found.</div>
          )}

          {filtered.map((user, i) => (
            <div key={user._id} style={{
              display: 'grid', gridTemplateColumns: '1.8fr 2fr 1fr 1fr 1fr',
              padding: '14px 24px', borderTop: '1px solid var(--border)',
              alignItems: 'center', gap: 12,
              background: i % 2 === 0 ? 'transparent' : 'rgba(255,255,255,0.01)',
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                <div style={{
                  width: 36, height: 36, borderRadius: '50%',
                  background: 'linear-gradient(135deg, var(--gold), var(--amber))',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontWeight: 900, fontSize: '0.85rem', color: '#0f0e17', flexShrink: 0,
                }}>
                  {user.name[0].toUpperCase()}
                </div>
                <span style={{ fontWeight: 700, color: 'var(--text)', fontSize: '0.88rem' }}>{user.name}</span>
              </div>
              <span style={{ color: 'var(--text2)', fontSize: '0.85rem' }}>{user.email}</span>
              <span style={{ color: 'var(--text2)', fontWeight: 700 }}>
                {(user.purchasedBooks || []).length}
              </span>
              <span style={{ color: 'var(--text2)', fontWeight: 700 }}>
                {(user.purchasedChapters || []).length}
              </span>
              <span style={{ color: 'var(--text3)', fontSize: '0.8rem' }}>
                {new Date(user.createdAt).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' })}
              </span>
            </div>
          ))}
        </div>
      )}
    </AdminLayout>
  );
}
